import {Component, EventEmitter, Input, OnInit} from '@angular/core';
import {CardState, revealExpand, rotateArrow} from '../../../animations';
import { Console } from 'console';

@Component({
  selector: 'as-reveal',
  templateUrl: './reveal.component.html',
  styleUrls: ['./reveal.component.scss'],
  animations: [revealExpand, rotateArrow]
})
export class RevealComponent implements OnInit {

  @Input() label;
  @Input() grid: boolean = false;
  @Input() htmlLabel;
  @Input() count;
  @Input() isOpen: boolean = false;
  @Input() openAll: EventEmitter<any>;

  state = [];
  subscribers = [];

  ngOnInit() {

    if (this.openAll) {
      this.subscribers.push(this.openAll.subscribe((c) => {
        this.expandAll(c)
      }));
    }

    if (this.isOpen) {
      this.state.push(CardState.Open)
    } else {
      this.state.push(CardState.Closed)
    }

  }

  expandSubList(index) {
    this.state[index] = (this.state[index] == CardState.Open) ? CardState.Closed : CardState.Open;
  }

  expandAll(action) {
    this.state = [];
    if (action) {
      this.state.push(CardState.Open)
    } else {
      this.state.push(CardState.Closed)
    }
  }

  ngOnChanges(){
    this.state = [];

    if (this.isOpen) {
      this.state.push(CardState.Open)
    } else {
      this.state.push(CardState.Closed)
    }
  }

  ngOnDestroy(){
    this.subscribers.forEach((s)=>s.unsubscribe);
  }

}
